export const CardData = [
  {
    date: "April 16th 2020",
    title: "the mountains",
    author: "john appleseed",
    image: {
      desktop: require("./assets/stories/desktop/mountains.jpg"),
      mobile: require("./assets/stories/mobile/mountains.jpg"),
    },
  },
  {
    date: "April 14th 2020",
    title: "sunset cityscapes",
    author: "benjamin cruz",
    image: {
      desktop: require("./assets/stories/desktop/cityscapes.jpg"),

      mobile: require("./assets/stories/mobile/cityscapes.jpg"),
    },
  },
  {
    date: "April 11th 2020",
    title: "18 days voyage",
    author: "alexei borodin",
    image: {
      desktop: require("./assets/stories/desktop/18-days-voyage.jpg"),

      mobile: require("./assets/stories/mobile/18-days-voyage.jpg"),
    },
  },
  {
    date: "April 9th 2020",
    title: "architecturals",
    author: "samantha brooke",
    image: {
      desktop: require("./assets/stories/desktop/architecturals.jpg"),

      mobile: require("./assets/stories/mobile/architecturals.jpg"),
    },
  },
  {
    date: "April 7th 2020",
    title: "world tour 2019",
    author: "timothy wagner",
    image: {
      desktop: require("./assets/stories/desktop/world-tour.jpg"),

      mobile: require("./assets/stories/mobile/world-tour.jpg"),
    },
  },
  {
    date: "April 3rd 2020",
    title: "unforeseen corners",
    author: "william malcolm",
    image: {
      desktop: require("./assets/stories/desktop/unforeseen-corners.jpg"),

      mobile: require("./assets/stories/mobile/unforeseen-corners.jpg"),
    },
  },
  {
    date: "march 29th 2020",
    title: "king of africa: part II",
    author: "tim hillenburg",
    image: {
      desktop: require("./assets/stories/desktop/king-on-africa.jpg"),

      mobile: require("./assets/stories/mobile/king-on-africa.jpg"),
    },
  },
  {
    date: "march 21st 2020",
    title: "the trip to nowhere",
    author: "felicia rourke",
    image: {
      desktop: require("./assets/stories/desktop/trip-to-nowhere.jpg"),

      mobile: require("./assets/stories/mobile/trip-to-nowhere.jpg"),
    },
  },
  {
    date: "march 19th 2020",
    title: "rage of the sea",
    author: "mohammed abdul",
    image: {
      desktop: require("./assets/stories/desktop/rage-of-the-sea.jpg"),

      mobile: require("./assets/stories/mobile/rage-of-the-sea.jpg"),
    },
  },
  {
    date: "march 16th 2020",
    title: "running free",
    author: "michelle",
    image: {
      desktop: require("./assets/stories/desktop/running-free.jpg"),

      mobile: require("./assets/stories/mobile/running-free.jpg"),
    },
  },
  {
    date: "march 11th 2020",
    title: "behind the waves",
    author: "lamar wilson",
    image: {
      desktop: require("./assets/stories/desktop/behind-the-waves.jpg"),

      mobile: require("./assets/stories/mobile/behind-the-waves.jpg"),
    },
  },
  {
    date: "march 9th 2020",
    title: "calm waters",
    author: "samantha brooke",
    image: {
      desktop: require("./assets/stories/desktop/calm-waters.jpg"),

      mobile: require("./assets/stories/mobile/calm-waters.jpg"),
    },
  },
  {
    date: "march 5th 2020",
    title: "the milky way",
    author: "benjamin cruz",
    image: {
      desktop: require("./assets/stories/desktop/milky-way.jpg"),

      mobile: require("./assets/stories/mobile/milky-way.jpg"),
    },
  },
  {
    date: "march 4th 2020",
    title: "night at the dark forest",
    author: "mohammed abdul",
    image: {
      desktop: require("./assets/stories/desktop/dark-forest.jpg"),

      mobile: require("./assets/stories/mobile/dark-forest.jpg"),
    },
  },
  {
    date: "march 1st 2020",
    title: "somwarpet's beauty",
    author: "michelle",
    image: {
      desktop: require("./assets/stories/desktop/somwarpet.jpg"),

      mobile: require("./assets/stories/mobile/somwarpet.jpg"),
    },
  },
  {
    date: "february 25th 2020",
    title: "land of dreams",
    author: "william malcolm",
    image: {
      desktop: require("./assets/stories/desktop/land-of-dreams.jpg"),

      mobile: require("./assets/stories/mobile/land-of-dreams.jpg"),
    },
  },
];
